<!-- Flight Extras Block -->
<div class="flight-extras-container" [formGroup]="form">
  @if (displayWarning) {
    <div i18n="@@flightExtrasWarningText" class="extras_warning">
      Extras Selected On The Outbound Apply To The Entire Journey
    </div>
  }
  <div class="half-container">
    @if (showExtras) {
      <div class="half-block">
        <label class="header-label" id="flightExtrasLabel" for="flightExtras">
          <span i18n="@@flight-extras">Flight Extras</span>:
          @if (hideExtras && extraOptions?.extras) {
            <section class="container" (mouseleave)="tt1.close()">
              <i
                class="ico-info"
                i18n-ngbTooltip
                [ngbTooltip]="'Added extras is per whole booking'"
                triggers="manual"
                #tt1="ngbTooltip"
                (mouseenter)="tt1.open()"
                (focus)="tt1.open()"
                (blur)="tt1.close()"
                tabindex="0"
              ></i>
            </section>
          }
        </label>
        <input
          type="text"
          class="extras-typeahead"
          aria-labelledby="flightExtrasLabel"
          id="flightExtras"
          formControlName="flightExtras"
          [ngbTypeahead]="searchExtras"
          [resultTemplate]="extrasRt"
          [inputFormatter]="formatOption"
          [editable]="false"
          [focusFirst]="false"
          readonly
          #extrasTa="ngbTypeahead"
          (focus)="focus$.flightExtras.next($any($event.target).value)"
          (click)="click$.flightExtras.next($any($event.target).value)"
          (keydown.arrowdown)="
            !extrasTa.isPopupOpen() && click$.flightExtras.next($any($event.target).value)
          "
          (keydown.space)="
            !extrasTa.isPopupOpen() && click$.flightExtras.next($any($event.target).value);
            $event.preventDefault()
          "
          (selectItem)="updateFlightExtras('flightExtras', $event)"
        />
        <ng-template #extrasRt let-r="result">
          <div class="extras-typeahead-option">{{ formatOption(r) }}</div>
        </ng-template>
      </div>
    }
    @if (showExtras) {
      <div class="half-block">
        <label class="header-label" id="luggageOptionsLabel" for="luggageOptions">
          <span i18n="@@ShowDetailsLuggageOptions">Luggage Options:</span>
          @if (!showTFXLuggage && extraOptions?.luggage) {
            <section class="container" (mouseleave)="tt2.close()">
              <i
                class="ico-info"
                i18n-ngbTooltip
                [ngbTooltip]="'Added extras is per whole booking'"
                tabindex="0"
                triggers="manual"
                #tt2="ngbTooltip"
                (mouseenter)="tt2.open()"
                (focus)="tt2.open()"
                (blur)="tt2.close()"
              ></i>
            </section>
          }
        </label>
        <input
          type="text"
          class="extras-typeahead"
          aria-labelledby="luggageOptionsLabel"
          id="luggageOptions"
          formControlName="baggageAllowance"
          [ngbTypeahead]="searchLuggage"
          [resultTemplate]="luggageRt"
          [inputFormatter]="formatOption"
          [editable]="false"
          [focusFirst]="false"
          readonly
          #luggageTa="ngbTypeahead"
          (focus)="focus$.baggageAllowance.next($any($event.target).value)"
          (click)="click$.baggageAllowance.next($any($event.target).value)"
          (keydown.arrowdown)="
            !luggageTa.isPopupOpen() && click$.baggageAllowance.next($any($event.target).value)
          "
          (keydown.space)="
            !luggageTa.isPopupOpen() && click$.baggageAllowance.next($any($event.target).value);
            $event.preventDefault()
          "
          (selectItem)="updateFlightExtras('baggageAllowance', $event)"
        />
        <ng-template #luggageRt let-r="result">
          <div class="extras-typeahead-option">{{ formatOption(r) }}</div>
        </ng-template>
      </div>
    }
  </div>
  <div class="half-container">
    @if (showExtras) {
      <div class="half-block">
        <label
          class="header-label"
          id="advancedAncillaryOptionsLabel"
          for="advancedAncillaryOptions"
        >
          <span i18n="@@ShowDetailsAdvancedAncillaryOptions">Advanced Ancillary Options:</span>
          @if (hideAncillary) {
            <section class="container" (mouseleave)="tt3.close()">
              <i
                class="ico-info"
                i18n-ngbTooltip
                [ngbTooltip]="'Added extras is per whole booking'"
                tabindex="0"
                triggers="manual"
                #tt3="ngbTooltip"
                (mouseenter)="tt3.open()"
                (focus)="tt3.open()"
                (blur)="tt3.close()"
              ></i>
            </section>
          }
        </label>
        <input
          type="text"
          class="extras-typeahead"
          aria-labelledby="advancedAncillaryOptionsLabel"
          id="advancedAncillaryOptions"
          formControlName="advancedAncillaryOptions"
          [ngbTypeahead]="searchAncillary"
          [resultTemplate]="ancillaryRt"
          [inputFormatter]="formatOption"
          [editable]="false"
          [focusFirst]="false"
          readonly
          #ancillaryTa="ngbTypeahead"
          (focus)="focus$.advancedAncillaryOptions.next($any($event.target).value)"
          (click)="click$.advancedAncillaryOptions.next($any($event.target).value)"
          (keydown.arrowdown)="
            !ancillaryTa.isPopupOpen() &&
              click$.advancedAncillaryOptions.next($any($event.target).value)
          "
          (keydown.space)="
            !ancillaryTa.isPopupOpen() &&
              click$.advancedAncillaryOptions.next($any($event.target).value);
            $event.preventDefault()
          "
          (selectItem)="updateFlightExtras('advancedAncillaryOptions', $event)"
        />
        <ng-template #ancillaryRt let-r="result">
          <div class="extras-typeahead-option">{{ formatOption(r) }}</div>
        </ng-template>
      </div>
    }
    <div class="half-block">
      <label
        class="header-label"
        id="reducedMobillityAssistanceLabel"
        i18n="@@reducedMobillityAssistance"
        for="ShowDetailsReducedMobillityAssistance"
      >
        Reduced Mobillity Assistance:
      </label>
      <input
        type="text"
        class="extras-typeahead"
        aria-labelledby="reducedMobillityAssistanceLabel"
        id="reducedMobillityAssistance"
        formControlName="reducedMobillityAssistance"
        [ngbTypeahead]="searchMobility"
        [resultTemplate]="mobilityRt"
        [inputFormatter]="formatOption"
        [editable]="false"
        [focusFirst]="false"
        readonly
        #mobilityTa="ngbTypeahead"
        (focus)="focus$.reducedMobillityAssistance.next($any($event.target).value)"
        (click)="click$.reducedMobillityAssistance.next($any($event.target).value)"
        (keydown.arrowdown)="
          !mobilityTa.isPopupOpen() &&
            click$.reducedMobillityAssistance.next($any($event.target).value)
        "
        (keydown.space)="
          !mobilityTa.isPopupOpen() &&
            click$.reducedMobillityAssistance.next($any($event.target).value);
          $event.preventDefault()
        "
        (selectItem)="updateFlightExtras('reducedMobillityAssistance', $event)"
      />
      <ng-template #mobilityRt let-r="result">
        <div class="extras-typeahead-option">{{ formatOption(r) }}</div>
      </ng-template>
    </div>
  </div>
</div>
